import { ErrorDialogContext, errorHandledAsync } from "@/shared/context/error-context";
import { useContext } from "react";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useTwoStepAuthSetStates } from "@/features/two-step-authentication/hooks/use-two-step-authentication-set-states";
import { TwoStepAuthService } from "@/features/two-step-authentication/services/two-step-authentication-service";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";

interface Props {
  onTapCompleteModal: () => void;
}

// 2段階認証設定画面
export const useTwoStepAuthSet = ({ onTapCompleteModal }: Props) => {
  const {
    setOpenHomeModal,
  } = useModalContext();
  const twoStepAuthService = new TwoStepAuthService();
  const {
    isValid,
    setIsValid,
  } = useTwoStepAuthSetStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);
  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const setTwoStepAuthValidState = async () => {
    loadingCtx.setIsLoading(true);
    try {
      const res = await twoStepAuthService.getTwoStepAuth({});
      setIsValid(res.is_used);
    } catch (error) {
      // モーダルを再度開きなおすようにメッセージ出して、初期値（無効）で表示になる？
      console.log("setTwoStepAuthValidState:", error);
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // 有効化ボタン押下イベント
  const onClickValid = async (
    valid: number,
  ) => {
    if (valid === 1) return;
    loadingCtx.setIsLoading(true);
    try {
      // 認証コード発行
      twoStepAuthService.generateTwoStepAuthCode({
        purpose: "setting",
      });
      setOpenHomeModal("TwoStepAuthSetCode");
    } catch (error) {
      // エラーダイアログ？
      console.log("onClickValid:", error);
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  // 無効化ボタン押下イベント
  const onClickInvalid = async (
    valid: number,
  ) => {
    if (valid === 0) return;
    loadingCtx.setIsLoading(true);
    try {
      await twoStepAuthService.updateTwoStepAuth({
        is_used: 0, // 0:無効
      });

      onTapCompleteModal();
    } catch (error) {
      // エラーダイアログ？
      console.log("onClickInvalid:", error);
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    isValid,
    setIsValid,
    setTwoStepAuthValidState: errorHandledAsync(setTwoStepAuthValidState, setError),
    onClickValid: errorHandledAsync(onClickValid, setError),
    onClickInvalid: errorHandledAsync(onClickInvalid, setError),
  };
};
